import React, { useEffect, useState } from 'react';
import { Col, Row, Button } from 'reactstrap';

//Components
import TextField from '../../../../components/TextField/TextField';

//API
import destino_api from '../../../../api/destino_api';
import { showMessage, showQuestion } from '../../../../helpers/message';
import Loading from '../../../../components/Loading/Loading';

//API
import transportador_api from '../../../../api/transportador_api';
import redestinacao_api from '../../../../api/redestinacao_api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faEdit, faSave, faTruck } from '@fortawesome/free-solid-svg-icons';
import { objCampo } from 'helpers/ValidadorDeCampos';
import { validarCampos } from 'helpers/ValidadorDeCampos';


function Transporte_Destinacao({ redestinacaoItem, setRedestinacao, setActiveStep, btnVoltar }) {

  const [destinos, setDestinos] = useState([]);

  const [transportadores, setTransportadores] = useState([]);

  const [veiculos, setVeiculos] = useState([]);

  //Controle dos erros dos campos obrigatorios
  const [errors, setErrors] = useState({});

  //Estado de controle do loading na tela
  const [loading, setLoading] = useState(false);

  const [modalidades, setModalidades] = useState(redestinacaoItem?.redestinacaoTipoColetas?.filter(x => x.pesoDestinado != "" && x.pesoDestinado != "0,00")?.map(({ tbTipoColeta_Id }) => tbTipoColeta_Id) ?? []);

  //Campos obrigatorios
  const [camposRedestinacaoItem, setCamposRedestinacaoItem] = useState(
    [objCampo({ name: "tbTransportadores_Id", required: true })]
  )

  //Campos obrigatorios
  const camposRedestinacaoDestino = [
    objCampo({ name: "tbDestinos_Id", required: true }),
    objCampo({ name: "tbTransportadores_Id", required: true }),
    objCampo({ name: "tbVeiculos_Id", required: true })
  ]

  //Função de onChange do campo de fiscal do agendamento
  const onChangeSelectSearch = (e, select) => {
    const { name } = select;
    const _redestinacaoItem = {
      ...redestinacaoItem,
      redestinacaoDestino: {
        ...redestinacaoItem.redestinacaoDestino,
        [name]: e && e?.value ? e.value.toString() : "",
      }
    };
    const erros = validarCampos(_redestinacaoItem.redestinacaoDestino, camposRedestinacaoDestino.filter(c => c.name == name));
    if (erros[1].length == 0) {
      const _errors = { ...errors };
      delete _errors[name];
      setErrors(_errors);
    }
    setRedestinacao(_redestinacaoItem)
  }

  //Função de onChange do campo de fiscal do agendamento
  const onChangeSelect = (e, select) => {
    const { name } = select;
    const _redestinacaoItem = {
      ...redestinacaoItem,
      [name]: e && e.value ? e.value.toString() : ""
    };
    const erros = validarCampos(_redestinacaoItem, camposRedestinacaoItem.filter(c => c.name == name));
    if (erros[1].length == 0) {
      const _errors = { ...errors };
      delete _errors[name];
      setErrors(_errors);
    }
    setRedestinacao(_redestinacaoItem)
  }

  const loadVeiculosModalidade = (transportador_Id, list) => {
    setLoading(true)
    redestinacao_api.PostListVeiculosTransportadoresModalidade(transportador_Id, list)
      .then(response => {
        response.data = response.data.filter(x => x.id != redestinacaoItem?.tbDestinos_Id).map(value => {
          value.label = value.placa;
          value.value = value.id;
          return value;
        });

        setVeiculos(response.data)
      })
      .catch(e => showMessage("Aviso", e.message, "error", null))
      .finally(() => setLoading(false))
  }

  const loadTransportadoresModalidade = (list) => {
    setLoading(true)
    redestinacao_api.PostListTransportadoresModalidade(list)
      .then(response => {
        response.data = response.data.map(value => {
          value.label = value.fantasia;
          value.value = value.id;
          return value;
        });

        if (response.data.filter(x => x.value == redestinacaoItem?.tbTransportadores_Id).length == 0 || response.data.length == 0) {
          setRedestinacao({
            ...redestinacaoItem,
            tbTransportadores_Id: "",
            tbVeiculos_Id: ""
          })
        }

        setTransportadores(response.data)
      })
      .catch(e => showMessage("Aviso", e.message, "error", null))
      .finally(() => setLoading(false))
  }

  const loadDestinoModalidade = (list) => {
    setLoading(true)
    redestinacao_api.PostListDestinosPorModalidade(list)
      .then(response => {
        response.data = response.data.filter(x => x.id != redestinacaoItem?.tbDestinos_Id).map(value => {
          value.label = value.fantasia;
          value.value = value.id;
          return value;
        });

        if (response.data.filter(x => x.value == redestinacaoItem?.redestinacaoDestino?.tbDestinos_Id).length == 0) {
          setRedestinacao({
            ...redestinacaoItem,
            redestinacaoDestino: {
              ...redestinacaoItem.redestinacaoDestino,
              tbDestinos_Id: ""
            }
          })
        }

        setDestinos(response.data)
      })
      .catch(e => showMessage("Aviso", e.message, "error", null))
      .finally(() => setLoading(false))
  }

  const onSubmit = () => {
    const erros = validarCampos(redestinacaoItem, camposRedestinacaoItem);
    setErrors(erros[0]);
    if (erros[1].length > 0) {
      return;
    }

    const _redestinacao = { ...redestinacaoItem };
    _redestinacao.redestinacaoTipoColetas = _redestinacao.redestinacaoTipoColetas?.filter(x => x.pesoDestinado != "" && x.pesoDestinado != "0,00");
    _redestinacao.redestinacaoTipoColetas = _redestinacao.redestinacaoTipoColetas.map(value => {
      value.pesoDestinado = parseFloat(value.pesoDestinado.toString().replace(",", "."))
      return value
    });

    _redestinacao.redestinacaoDestino.tbDestinos_Id = _redestinacao.redestinacaoDestino.tbDestinos_Id == "" ? null : _redestinacao.redestinacaoDestino.tbDestinos_Id;

    if (!_redestinacao.id) {
      setLoading(true);
      redestinacao_api.Post(_redestinacao).then(response => {
        showMessage("Sucesso", "Gerador cadastrado com sucesso", "success", null);
        response.data.redestinacaoDestino.id = response.data?.redestinacaoDestino?.id ? response.data.redestinacaoDestino?.id.toString() : "";
        response.data.tbTransportadores_Id = response.data?.tbTransportadores_Id ? response.data.tbTransportadores_Id.toString() : "";
        response.data.tbVeiculos_Id = response.data?.tbVeiculos_Id ? response.data?.tbVeiculos_Id?.toString() : "";
        setRedestinacao(response.data);
      }).catch(e => {
        showMessage("Aviso", e.message, "error", null);
      }).finally(f => setLoading(false));
    } else {
      delete _redestinacao.dataRegistro;
      setLoading(true);
      redestinacao_api.Put(_redestinacao).then(response => {
        showMessage("Sucesso", "Gerador cadastrado com sucesso", "success", null);
        response.data.redestinacaoDestino.id = response.data?.redestinacaoDestino?.id ? response.data.redestinacaoDestino?.id.toString() : "";
        response.data.tbTransportadores_Id = response.data?.tbTransportadores_Id ? response.data.tbTransportadores_Id.toString() : "";
        response.data.tbVeiculos_Id = response.data?.tbVeiculos_Id ? response.data?.tbVeiculos_Id?.toString() : "";
        setRedestinacao(response.data);
      }).catch(e => {
        showMessage("Erro", e.message, "error", null);
      }).finally(f => setLoading(false));
    }
  }

  const handleAtualizarStatusRedestinacao = () => {
    const _validacao = {
      tbDestinos_Id: redestinacaoItem.redestinacaoDestino.tbDestinos_Id,
      tbTransportadores_Id: redestinacaoItem.tbTransportadores_Id,
      tbVeiculos_Id: redestinacaoItem.tbVeiculos_Id
    };

    const erros = validarCampos(_validacao, camposRedestinacaoDestino);
    setErrors(erros[0]);
    if (erros[1].length > 0) {
      return;
    }

    const _redestinacao = { ...redestinacaoItem };

    _redestinacao.redestinacaoTipoColetas = _redestinacao.redestinacaoTipoColetas?.filter(x => x.pesoDestinado != "" && x.pesoDestinado != "0,00");
    _redestinacao.redestinacaoTipoColetas = _redestinacao.redestinacaoTipoColetas.map(value => {
      value.pesoDestinado = parseFloat(value.pesoDestinado.toString().replace(",", "."))
      return value
    });

    delete _redestinacao.dataRegistro;
    _redestinacao.status = "Coletado";

    setLoading(true);
    redestinacao_api.EnviarResiduo(_redestinacao)
      .then(response => {
        showMessage("Sucesso", "Operação executada com sucesso.", "success", btnVoltar);
        setRedestinacao(response.data);
      }).catch(e => {
        showMessage("Aviso", e.message, "error", null);
      }).finally(f => setLoading(false));
  }

  useEffect(() => {
    loadTransportadoresModalidade(modalidades);
    loadDestinoModalidade(modalidades);

    if (!!redestinacaoItem?.tbTransportadores_Id)
      loadVeiculosModalidade(redestinacaoItem?.tbTransportadores_Id, modalidades);
  }, []);

  useEffect(() => {
    if (!!redestinacaoItem?.tbTransportadores_Id && modalidades?.length > 0) {
      loadVeiculosModalidade(redestinacaoItem?.tbTransportadores_Id, modalidades);
    }
  }, [redestinacaoItem?.tbTransportadores_Id])

  return (
    <div className='m-4 p-2 rounded-3 containerStep'>
      {loading && <Loading />}
      <Row className='mb-2'>
        <Col md={"12"} lg={"4"}>
          <TextField
            name={"tbTransportadores_Id"}
            onChange={onChangeSelect}
            label={"* Transportador"}
            type={"select"}
            value={transportadores.filter(x => x.value == redestinacaoItem?.tbTransportadores_Id)[0]}
            searchable
            options={transportadores}
            invalid={!!errors.tbTransportadores_Id}
          />
        </Col>
        <Col md={"12"} lg={"4"}>
          <TextField
            name={"tbVeiculos_Id"}
            onChange={onChangeSelect}
            label={"Veiculo"}
            type={"select"}
            value={veiculos.filter(x => x.value == redestinacaoItem?.tbVeiculos_Id)[0]}
            searchable
            options={veiculos}
            invalid={!!errors.tbVeiculos_Id}
          />
        </Col>
        <Col md={"12"} lg={"4"}>
          <TextField
            name={"tbDestinos_Id"}
            onChange={onChangeSelectSearch}
            label={"Destino"}
            type={"select"}
            value={destinos.filter(x => x.value == redestinacaoItem?.redestinacaoDestino?.tbDestinos_Id)[0]}
            searchable
            options={destinos}
            invalid={!!errors.tbDestinos_Id}
          />
        </Col>
      </Row>
      <div className='d-flex justify-content-center align-items-center gap-3'>
        <div >
          <Button
            color='success'
            className='bg-gradient d-flex align-items-center'
            onClick={() => setActiveStep(1)}><FontAwesomeIcon icon={faArrowLeft} className={"me-3"} /> Anterior</Button>
        </div>
        <div className='text-end'>
          <Button
            color={"primary"}
            onClick={onSubmit}
          >
            <span className='text-white'><FontAwesomeIcon icon={faSave} color='white' /> Salvar</span>
          </Button>
        </div>
        <div className='text-start'>
          <Button
            color={"warning"}
            onClick={handleAtualizarStatusRedestinacao}
          >
            <span className='text-white'><FontAwesomeIcon icon={faTruck} color='white' /> Enviar Resíduos</span>
          </Button>
        </div>
      </div>
    </div>
  );
}

export default Transporte_Destinacao;